module.exports = __webpack_public_path__ + "img/object-mark10.9612217a.png";